const el_GR = {
    homepage_title: 'Λήψη CalendarTask έκδοση mobile με QR code',
    homepage_slogn: 'CalendarTask έκδοση mobile',
    homepage_ios_download: 'App Store υπό έλεγχο...',
    homepage_download: 'Λήψη',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Λήψη CalendarTask έκδοση mobile με QR code',
    phonedownload_slogan: 'Συγχρονισμός με PC & tablet, σημειώσεις παντού',
    phonedownload_send_vip: 'Εγκαταστήστε την εφαρμογή και λάβετε συνδρομή VIP',
    phonedownload_screenshot: 'Στιγμιότυπο οθόνης',
    phodedownload_macos: 'CalendarTask έκδοση macOS',
    phodedownload_windows: 'CalendarTask έκδοση Windows',
    phodedownload_otherbutton: 'Δείτε τώρα',
    phodedownload_about: 'Επικοινωνία',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Χωρίς διαφημίσεις',
    feature_easy: 'Μηνιαία προβολή, απλή και εύκολη',
    feature_reminder: 'Προσαρμοσμένη υπενθύμιση',
    feature_countdown: 'Αντίστροφη μέτρηση επετείου',

    vip_task_succ: 'Επιτυχία. Κατεβάστε την εφαρμογή για VIP',
    vip_task_error: 'Αποτυχία λήψης',

    group_slogn: 'Πρόσκληση CalendarTask ομάδας',

    tt_title: 'CalendarTask',
    tt_share_1: 'Κοινόχρηστο μαζί σας',
    tt_share_2: 'Πρόγραμμα',
    tt_share_show_1: 'Σαρώστε το QR code με την εφαρμογή "CalendarTask", PC και κινητό θα εμφανίσουν',
    tt_share_show_2: 'το πρόγραμμα',
    tt_share_scan_1: 'Σάρωση με',
    tt_share_scan_2: 'εφαρμογή "CalendarTask"',
    tt_share_succ: 'Επιτυχής συγχρονισμός',

    v2_copyright: 'Επικοινωνία service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Με επιφύλαξη παντός δικαιώματος.',
    v2_download_appstore: 'Λήψη στο App Store',
    v2_download_googleplay: 'Διαθέσιμο στο Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Αναζητήστε <span class="name">CalendarTask</span> στο App Store ή Google Play',
    v2_download_ios: 'Λήψη iOS',
    v2_download_android: 'Λήψη Android',
    v2_download_harmonyos: 'Λήψη HarmonyOS',
    v2_sync_status: 'Συγχρονισμός ολοκληρώθηκε! 1 ανεβάστηκε, 0 κατεβήκαν',
    v2_feature_title: 'Συγχρονισμός δεδομένων πολλών συσκευών',
    v2_feature_description: 'Συγχρονισμός κινητού, tablet και PC'
};
export default el_GR;
